import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify'; // Optional for alerts

const GlobalBrandAdd = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    special_offer_image: null,
    brand_logo: null,
    discount: '',
    title: '',
    products: "",
    current_price: "",
    old_price: "",
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e, field) => {
  const file = e.target.files[0];
  if (file) {
    setFormData(prev => ({ ...prev, [field]: file }));
    if (field === 'special_offer_image') setPreviewImage(URL.createObjectURL(file));
    if (field === 'brand_logo') setPreviewLogo(URL.createObjectURL(file));
  }
};

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setLoading(true);
    const data = new FormData();
    data.append("special_offer_image", formData.special_offer_image);
    data.append("brand_logo", formData.brand_logo);
    data.append("discount", formData.discount);
    data.append("title", formData.title);
    data.append("products", formData.products);
    data.append("current_price", formData.current_price);
    data.append("old_price", formData.old_price);

    // Debug check
    for (let [key, value] of data.entries()) {
      console.log(key, value);
    }

    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_special_offer",
      data,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response.data.status) {
      toast.success("Special Offer added successfully!");
      navigate("/Offer");
    } else {
      toast.error(response.data.message || "Failed to add Special Offer");
    }
  } catch (error) {
    console.error("Error adding Special Offer:", error);
    toast.error("Something went wrong while adding the Special Offer");
  } finally {
    setLoading(false);
  }
};



  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Add special offer</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><a href="#">Special Offer</a></li>
            <li className="breadcrumb-item active">Add</li>
          </ol>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">New Special Offer</h4>
            </div>
            <div className="card-body row">
              <div className="col-lg-6 mb-3">
                <label className="form-label">Main Image</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'special_offer_image')}
                />
                {previewImage && <img src={previewImage} alt="Preview" height="80" className="mt-2" />}
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Brand Logo</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'brand_logo')}
                />
                {previewLogo && <img src={previewLogo} alt="brand_logo" height="80" className="mt-2" />}
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Product Name</label>
                <input
                  type="text"
                  name="products"
                  value={formData.products}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Product Name"
                  required
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Title"
                  required
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Current Price</label>
                <input
                  type="text"
                  name="current_price"
                  value={formData.current_price}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Current Price"
                  required
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Old Price</label>
                <input
                  type="text"
                  name="old_price"
                  value={formData.old_price}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Title"
                  required
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Discount</label>
                <input
                  type="text"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="e.g., 50% Off"
                  required
                />
              </div>
            </div>

            <div className="card-footer">
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Saving..." : "Save Special Offer"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GlobalBrandAdd;
